import { DeployerGridWebComponent } from './component/DeployerGridWebComponent';
import { WEB_COMPONENT_DEPLOYER_GRID } from '../../../webcomponents.constants';

export { DeployerGridWebComponent };

window.customElements.define(WEB_COMPONENT_DEPLOYER_GRID, DeployerGridWebComponent);
